<mat-form-field [appearance]="appearance" fxFlex *ngIf="!selectedCompany">
  <mat-label *ngIf="floatLabel">{{ floatLabelText ? floatLabelText : ('MAINTENANCES.COMPANY' | translate) }}</mat-label>
  <input
    [ngClass]="{ 'archived-selected': inputValue.value?.archived }"
    type="text"
    matInput
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
    [disabled]="disabled"
    [required]="required"
    placeholder="{{ 'MAINTENANCES.COMPANY_PLACEHOLDER' | translate }}"
    fxFlex="90"
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedCompany()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let company of companies" [value]="company" matTooltip="{{ company.name }}">
      <span [ngClass]="{ 'archived-selected': company.archived }">{{ company.name }}</span>
      <span class="archived-label" *ngIf="company.archived"> {{ 'MAINTENANCES.ARCHIVED' | translate }}</span>
    </mat-option>
    <mat-option *ngIf="!companies.length">
      {{ 'MAINTENANCES.COMPANY_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
  <mat-error class="pb-4">
    <span *ngIf="inputValue.hasError('required')">
      {{ 'MAINTENANCES.ERRORS.COMPANY_REQUIRED' | translate }}
    </span>
  </mat-error>
</mat-form-field>

<mat-form-field [appearance]="appearance" fxFlex *ngIf="selectedCompany" matTooltip="{{ selectedCompany.name }}">
  <mat-label *ngIf="floatLabel">
    {{ floatLabelText ? floatLabelText : ('MAINTENANCES.COMPANY' | translate) }}
  </mat-label>
  <input
    [ngClass]="{ 'archived-selected': selectedCompany.archived }"
    type="text"
    matInput
    [value]="selectedCompany.name"
    [required]="required"
    disabled
  />
  <button
    mat-icon-button
    matSuffix
    [disabled]="disabled"
    *ngIf="selectedCompany"
    class="my-cancel-button accent-700-fg"
    (click)="deselectCompany()"
  >
    <mat-icon class="font-size-20">cancel</mat-icon>
  </button>
</mat-form-field>
